import { NotificationStrategy } from '../../../../shared/services/notification/workflow';

export const downstreamStatusUpdateToAvStrategy: NotificationStrategy = {
  accept: async () => {
    throw new Error('DOWNSTREAM_STATUS_UPDATE_TO_AV does not support ACCEPT action');
  },
  reject: async () => {
    throw new Error('DOWNSTREAM_STATUS_UPDATE_TO_AV does not support REJECT action');
  },
};